import { z } from 'zod';

import { StepColorEnum } from '../../enums';

export const UpdateWordGroupSchema = z.object({
  description: z
    .string()
    .max(255, 'Description is too long')
    .nullable()
    .optional(),
  color: z.nativeEnum(StepColorEnum).optional(),
  lastDate: z.date().nullable().optional(),
  name: z.string().min(1, 'Name cannot be empty').optional(),
  nextDate: z.date().nullable().optional(),
});

export type IUpdateWordGroupDto = z.infer<typeof UpdateWordGroupSchema>;
